/**
 * Plan ve kullanım metinleri (M6 WP 6.1). Kabuk (menü, plan bildirimi) ve plan ekranı bu modülü kullanır; küçük tutulur.
 * Ücret, ödeme ve kendi kendine plan değiştirme SUNULMAZ — metinler bunu açıkça söyler.
 */
export const planText = {
  nav: 'Plan ve kullanım',
  title: 'Plan ve kullanım',
  description:
    'Çalışma alanınızın planı, açık özellikler ve kaynak tavanlarına göre güncel kullanım. Karar sunucudadır; bu ekran bilgilendirir.',
  loadFailed: 'Plan bilgisi yüklenemedi. Sayfayı yenileyip yeniden deneyin.',
  currentPlan: 'Geçerli plan',
  assignedAt: (d: string) => `Son atama: ${d}`,
  notAssigned: 'Varsayılan plan (atama yapılmadı)',
  demoTitle: 'Demo çalışma alanı',
  demoBody:
    'Demo çalışma alanında iş verisine bağlı dış etkiler (e-posta, davet, gelen e-posta hesabı, web kancası teslimi) plandan bağımsız olarak kapalıdır; hesabınız için güvenlik e-postaları (parola sıfırlama) gönderilebilir.',

  featuresTitle: 'Özellikler',
  featuresCount: (on: number, total: number) => `${String(on)} / ${String(total)} açık`,
  featureOn: 'Açık',
  featureOffShort: 'Planınızda yok',
  // F1 (TI-066): modül hakları — karar sunucudadır (`GET /plan` → `modules`); ekran yalnız söyler
  modulesTitle: 'Modüller',
  modulesHint:
    'Ek modüller planınıza dahil olabilir ya da Castinflow tarafından tanımlanır. Kapanan modülün verisi silinmez: kayıtlar görüntülenir ve dışa aktarılır, yeni işlem yapılamaz.',
  moduleState: { active: 'Açık', read_only: 'Salt okunur', off: 'Açık değil' },
  moduleSource: {
    plan: 'Planınıza dahil',
    grant: 'Castinflow tarafından tanımlandı',
    none: 'Bu çalışma alanında tanımlı değil',
  },
  moduleEnds: (date: string) => `Süre sonu: ${date}`,
  moduleLimitedBy: (label: string) => `“${label}” modülü açık olmadığı için sınırlı`,
  moduleReadOnlyNote: 'Kayıtlar görüntülenir ve dışa aktarılır; yeni işlem yapılamaz.',

  // v3.5: kullanım özeti kartları (yalnız sunucunun kullanım yanıtındaki sayılar)
  kpiTitle: 'Kullanım özeti',
  kpiLimit: (limit: string, percent: string | null) =>
    percent === null ? `Tavan: ${limit}` : `Tavan: ${limit} · ${percent}`,
  kpiUnlimited: 'Tavan yok (sınırsız)',
  meterTitle: 'Kullanım oranları',
  meterNote: 'Yalnız tavanı olan kaynaklar; oran kullanılan / tavan.',
  meterValue: (used: string, limit: string) => `${used} / ${limit}`,

  usageTitle: 'Kullanım ve tavanlar',
  usageAdminOnly: 'Kullanım ayrıntılarını yalnız çalışma alanı yöneticileri görür.',
  unlimited: 'sınırsız',
  of: (used: string, limit: string) => `${used} / ${limit}`,
  overridden: 'Çalışma alanınıza özel tavan',
  unavailable: 'Planınızda yok',
  unavailableKept: (n: string) =>
    `Planınızda yok. Mevcut ${n} tanım silinmedi; görüntülenebilir ama çalışmaz ve yenisi eklenemez.`,
  states: { ok: 'Normal', near: 'Sınıra yakın', at: 'Sınırda', over: 'Aşıldı' },
  // Bağlantılar iki AYRI göstergedir (K2): reklam hesapları kendi tavanını kullanır, diğer bağlantılara sayılmaz
  usageHints: {
    users:
      'Etkin, askıdaki ve daveti bekleyen kullanıcılar sayılır; ayrılan kullanıcılar sayılmaz. Ayrıntı: Yönetim › Kullanıcılar.',
    ad_accounts:
      'Etkin reklam hesabı bağlantıları (sosyal medya ve arama reklamları birlikte). Bağlantısı kesilen hesap sayılmaz.',
    provider_connections:
      'Reklam hesapları dışındaki etkin bağlantılar (mesajlaşma hesabı, sayfa ve benzeri). Reklam hesapları bu sayıya girmez.',
  } as Readonly<Record<string, string>>,
  bar: (label: string, used: string, limit: string) => `${label}: ${used} / ${limit}`,

  warnNear: 'Bazı kaynaklarda tavana yaklaşıldı',
  warnNearBody:
    'Tavan dolduğunda yeni oluşturma ya da yükleme reddedilir; mevcut veriler etkilenmez.',
  warnAt: 'Bazı kaynaklarda tavana ulaşıldı',
  warnAtBody:
    'Tavanı dolan kaynakta yeni oluşturma ya da yükleme reddedilir. Yer açmak için kullanılmayanları silebilir ya da plan değişikliği isteyebilirsiniz.',
  warnOver: 'Kullanım plan tavanının üstünde',
  warnOverBody:
    'Verileriniz silinmedi: görüntüleme, indirme ve dışa aktarma açık. Tavanı aşılan kaynakta yeni oluşturma ya da yükleme, kullanım tavanın altına inene ya da plan değişene dek kapalıdır.',
  // Reklam hesabı sınırı (v3.2 B): bu kaynakta yer açmanın yolu plan değişikliği istemek DEĞİL, kullanılmayan hesabın
  // bağlantısını kesmektir. YENİ hesap bağlamak sınıra sayılır; bağlı hesabın yetkisini YENİLEMEK sayılmaz
  warnAdAt: 'Reklam hesabı sınırına ulaşıldı',
  warnAdAtBody:
    'Yeni reklam hesabı bağlanamaz. Bağlı hesaplarınız çalışmaya devam eder ve yetkilerini yenilemek sınırı etkilemez. Yer açmak için kullanmadığınız bir reklam hesabının bağlantısını kesebilirsiniz.',
  warnAdOver: 'Bağlı reklam hesabı sayısı sınırın üstünde',
  warnAdOverBody:
    'Mevcut bağlantılarınız kapatılmadı: çalışmaya devam eder ve yetkileri yenilenebilir. Yalnız yeni reklam hesabı bağlanamaz; bağlı hesap sayısı sınırın altına indiğinde yeniden yer açılır. Yer açmak için kullanmadığınız bir reklam hesabının bağlantısını kesebilirsiniz.',

  // v3.1 S7 (U1): aylık kullanım ayrıntısı
  eventsTitle: 'Bu ayki kullanım ayrıntısı',
  eventsPeriod: (month: string, tz: string) => `Dönem: ${month} (saat dilimi: ${tz})`,
  eventsEmpty: 'Bu ay kayıtlı kullanım yok.',
  eventsLoadFailed: 'Kullanım ayrıntısı yüklenemedi.',
  eventsCostNote:
    'İleti ücretlerini sağlayıcı kendi hesabınıza faturalar; buradaki sayılar bilgi amaçlıdır, sağlayıcı faturası esastır.',
  eventsKind: 'Tür',
  eventsCategory: 'Kategori',
  eventsQuantity: 'Miktar',
  eventsNoCategory: '—',

  changeTitle: 'Plan değişikliği',
  changeBody:
    'Plan ve tavanlar bu ekrandan değiştirilemez; çevrim içi ödeme ve kendi kendine plan değiştirme sunulmuyor. Değişiklik için Castinflow ile iletişime geçin: atama Castinflow tarafından yapılır ve denetim izine yazılır.',

  // Özellik sayfalarındaki bildirim ve eylem yerine geçen açıklama
  featureOff: (label: string, plan: string) => `${label} "${plan}" planında bulunmuyor`,
  featureOffNoPlan: (label: string) => `${label} planınızda bulunmuyor`,
  featureOffBody:
    'Mevcut tanımlar görüntülenebilir; yenisi oluşturulamaz ve mevcut tanımlar çalışmaz. Plan değişikliği için Castinflow ile iletişime geçin.',
  actionOff: 'Planınızda yok',

  // v4.5 A-0: modül hakları (modules.ts). Karar sunucudadır; kapalı modülün rotası açıklama gösterir, menüde öğe çizilmez
  moduleOff: (label: string) => `${label} modülü bu çalışma alanında açık değil`,
  moduleOffBody:
    'Bu modüle ait kayıtlar ve işlemler çalışma alanınızda kullanılamıyor. Modülün açılması için Castinflow ile iletişime geçin; açma kararı denetim izine yazılır.',
  moduleReadOnly: 'Modül kapalı: kayıtlar görüntülenebilir, yeni işlem yapılamaz',
  moduleReadOnlyBody:
    'Geçmiş kayıtlar silinmedi; görüntülenebilir. Yeni kayıt ya da değişiklik yapılamaz.',
  moduleChecking: 'Modül durumu denetleniyor…',
};
